import React, { useRef, useMemo, useCallback } from "react";
import { Popup, ToolbarItem } from "devextreme-react/popup";
import TextBox from "devextreme-react/text-box";
import { useNavigate } from "react-router-dom";
import useFetch from "../../Hooks/useFetch";
import { isMobile } from "../../Utils/media-query";
import handlePostDenyPurchaseOrder from "../../Utils/handlePOST/handlePostDenyPurchaseOrder";

export default function DenyPurchaseOrders({
  orderId,
  setNotifications,
  onClose,
  mutate,
}) {
  const navigate = useNavigate();
  const fetch = useFetch(navigate);

  // store deny reason
  const denyReason = useRef("");

  const onValueChanged = (e) => {
    denyReason.current = e.value;
  };

  // ---------- SUBMIT DENY ----------
  const submitDeny = useCallback(async () => {
    if (!denyReason.current || denyReason.current.trim().length === 0) {
      setNotifications?.({
        success: false,
        message: "A reason is required to deny an order.",
      });
      return;
    }

    const { response, isDataGood } = await handlePostDenyPurchaseOrder(
      denyReason.current,
      orderId,
      fetch,
    );

    setNotifications?.(response);

    if (isDataGood) {
      mutate?.();
      onClose();
    }
  }, [orderId, fetch, setNotifications, onClose, mutate]);
  // ---------- BUTTON OPTIONS ----------
  const submitOptions = useMemo(
    () => ({
      stylingMode: "contained",
      type: "danger",
      text: "Deny PO Request",
      onClick: submitDeny,
    }),
    [submitDeny],
  );

  const cancelOptions = useMemo(
    () => ({
      stylingMode: "outlined",
      text: "Cancel",
      onClick: onClose,
    }),
    [onClose],
  );

  return (
    <Popup
      visible={true}
      onHiding={onClose}
      hideOnOutsideClick={true}
      title={`Deny PO Request ${orderId}`}
      width={isMobile ? "100%" : 500}
      height="auto"
      resizeEnabled={true}
    >
      <div style={{ padding: "12px" }}>
        <div style={{ marginBottom: "8px", fontWeight: 500, color: "white" }}>
          Please provide a reason for denying this PO request.
        </div>
      </div>
      <TextBox
        spellcheck={true}
        placeholder="Type comment..."
        onValueChanged={onValueChanged}
        valueChangeEvent="input"
        height={50}
      />
      <ToolbarItem
        widget="dxButton"
        toolbar="bottom"
        location="after"
        options={cancelOptions}
      />

      <ToolbarItem
        widget="dxButton"
        toolbar="bottom"
        location="after"
        options={submitOptions}
      />
    </Popup>
  );
}
